<!--
 * @Descripttion: 初始化默认列表
 * @Author: zenghua.wang
 * @Date: 2022-02-25 11:02:14
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-25 11:11:16
-->
<template>
  <el-table
    fit
    tooltip-effect="dark"
    :data="data"
    :size="option.size"
    :stripe="option.stripe"
    :border="option.border"
    :header-cell-style="headCellStyle"
  >
    <el-table-column
      v-if="option.index"
      type="index"
      label="序号"
      width="50"
      align="center"
      :index="1"
    />
    <el-table-column
      prop="id"
      label="学号"
      align="center"
    />
    <el-table-column
      prop="name"
      label="姓名"
      align="center"
    />
    <el-table-column
      prop="sex"
      label="性别"
      align="center"
    />
  </el-table>
</template>

<script>
export default {
  name: 'report-mock',
  props: ['data', 'option', 'headCellStyle']
}
</script>
